import { RefObject } from 'react'

import {
  insertAtCursor,
  isTextInsertable
} from 'modules/desktop/modules/stt/utils/insertAtCursor'
import { isSttPanelBlocked } from 'modules/desktop/modules/stt/utils/isSttPanelBlocked'
import { SttMessageType } from 'modules/desktop/modules/stt/utils/sttMessageTypes'

import { useInjectIframeScript } from './useInjectIframeScript'

export const useListenSpeechToText = (
  iframeRef: RefObject<HTMLIFrameElement>
) => {
  useInjectIframeScript(
    iframeRef,
    `
      const insertAtCursor = ${insertAtCursor.toString()}
      const isTextInsertable = ${isTextInsertable.toString()}
      const isSttPanelBlocked = ${isSttPanelBlocked.toString()}

      let lastInsertableEl = null

      const notifyFocusChange = (el) => {
        if (isSttPanelBlocked(el)) return
        const insertable = isTextInsertable(el)
        if (insertable) lastInsertableEl = el
        window.parent.postMessage(
          { type: '${SttMessageType.FocusChange}', isInsertable: insertable },
          window.parentOrigin || '*'
        )
      }

      document.addEventListener('focusin', (e) => notifyFocusChange(e.target))
      document.addEventListener('focusout', () => notifyFocusChange(null))

      window.addEventListener('message', (event) => {
        if (event.origin !== '${process.env.REACT_APP_CONTAINER_DOMAIN!}') return
        if (event.data?.type === '${SttMessageType.Result}') {
          insertAtCursor(event.data.result)
        } else if (event.data?.type === '${SttMessageType.RestoreFocus}' && lastInsertableEl) {
          lastInsertableEl.focus({ preventScroll: true })
        }
      })
    `
  )
}
